export default {
  props: {
    tab: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      tabKey: this.tab
    }
  },
  computed: {
    isCurrent () {
      return this.tab === this.tabKey
    }
  },
  methods: {
    startRefresh () {
      this.$emit('start-refresh', this.tabKey)
    },
    endRefresh () {
      this.$emit('end-refresh', this.tabKey)
    }
  }
}
